/**
 * Clave de bucket en `messagesByConversation` con soporte Asuntos V1.
 * Flag OFF o sin scope: solo conversacion_id (comportamiento histórico).
 * Flag ON + subjectRowId: `${cid}:subject:${subjectRowId}` (incluye fila default numérica).
 *
 * `conversationId` debe coincidir con `resolveCanonicalConversationIdFromRecord()` (tabla
 * `conversaciones`), nunca con id de contacto.
 */

import { toConversationId } from './toConversationId';

/**
 * @param {unknown} conversationId
 * @param {{ subjectsFeatureEnabled?: boolean, subjectRowId?: number|null }} [subjectsScope]
 * @returns {string|null}
 */
export function buildMessageScopeStoreKey(conversationId, subjectsScope = null) {
  const cid = toConversationId(conversationId);
  if (cid == null) return null;
  const base = String(cid);
  if (
    subjectsScope?.subjectsFeatureEnabled === true &&
    subjectsScope.subjectRowId != null
  ) {
    const sid = Number(subjectsScope.subjectRowId);
    if (Number.isFinite(sid) && sid > 0) {
      return `${base}:subject:${sid}`;
    }
  }
  return base;
}
